import * as Yup from "yup"
import { apolloClient } from "../../../ApolloWrapper/ApolloWrapper"
import { GET_BANK_DATA } from "../../../sepaDebitValidation/sepaDebit.graphql"
import { ModalDataType } from "./SepaDebitPaymentMethodModal"

const { string, object } = Yup

// type ModalDataValidationType = {[key in keyof ModalDataType]: Yup.MixedSchema<any>}
type ModalDataValidationType = {
    [key in keyof Pick<ModalDataType, "sepaAccountholder" | "iban" | "bank">]: any
}

export const SepaDebitValidationSchema = object().shape<ModalDataValidationType>({
    sepaAccountholder: string()
        .required("Bitte gib einen Kontoinhaber an.")
        .matches(
            /^([A-Za-z0-9\u00e4\u00fc\u00f6\u00c4\u00dc\u00d6\u00df\u00e0\u00e1\u00e2\u00e3\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f1\u00f2\u00f3\u00f4\u00f5\u00f9\u00fa\u00fb\u00c0\u00c1\u00c2\u00c3\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d1\u00d2\u00d3\u00d4\u00d5\u00d9\u00da\u00db\u00e7\u00c7\/\-\?\:\(\)\.\,\'\+\s]{2,})(?:,\s+|\s+)([A-Za-z0-9\u00e4\u00fc\u00f6\u00c4\u00dc\u00d6\u00df\u00e0\u00e1\u00e2\u00e3\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f1\u00f2\u00f3\u00f4\u00f5\u00f9\u00fa\u00fb\u00c0\u00c1\u00c2\u00c3\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d1\u00d2\u00d3\u00d4\u00d5\u00d9\u00da\u00db\u00e7\u00c7\/\-\?\:\(\)\.\,\'\+\s]{2,})$/,
            "Bitte gib den Kontoinhaber mit gültigen SEPA-Zeichen an (A-Z, a-z, 0-9, Umlaute, Akzente und Sonderzeichen: / - ? : ( ) . , ' +)."
        ),
    iban: string()
        .test("validatingIban", 'Bitte gib eine gültige IBAN ein. Bsp.: "DE 11 5205 1373 5120 7101 31, CH93 0076 2011 6238 5295 7, AT61 1904 3002 3457 3201"', async (iban) => {
            // console.log("===> iban:::", iban)
            if (iban !== undefined) {
                // console.log("===> iban:::", iban)
                const { data, errors } = await apolloClient.query({
                    query: GET_BANK_DATA,
                    variables: { iban },
                })

                if (errors) {
                    console.log("validatingIban errors: ", errors)
                }

                return data.getBankData.valid
            }
        })
        .required("Bitte gib eine IBAN ein."),
})

// Internationale IBAN
// /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/

// Deutsche IBAN
// /^DE\s*\d{2}\s*([0-9a-zA-Z]{4}\s*){4}[0-9a-zA-Z]{2}$/
